<template>
  <div class="grid grid--1 grid--gt-l--2 grid--centered" v-if="currentStep">
    <div class="grid__wrapper">
      <div class="grid__item">
        <div class="content" id="step">
          <span
            class="content__heading mod mod--size--42 mod--weight--300"
            v-html="currentStep.title"
          >
          </span>
        </div>
      </div>
      <div class="grid__item">
        <div class="stepper">
          <template v-for="(step, index) in steps">
            <div
              class="stepper__separator"
              v-show="index !== 0"
              :class="{
                'stepper__item--active': index <= currentIndex
              }"
              :key="'separator' + index"
            ></div>
            <div
              class="stepper__item"
              :class="{
                'stepper__item--active': index <= currentIndex
              }"
              :key="'item' + index"
              @click="goToStep(index)"
            >
              {{ index + 1 }}
              <span class="stepper__label">{{ step.label }}</span>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["steps"],
  name: "checkout-stepper",
  computed: {
    currentIndex: function() {
      return Math.max(this.steps.findIndex(step => step.active), 0);
    },
    currentStep: function() {
      return this.steps[this.currentIndex];
    }
  },
  methods: {
    goToStep: function(index) {
      this.$store.dispatch("updateSteps", {
        activeIndex: index
      });
    }
  }
};
</script>
